import React from "react";
import { Button } from "UiKit";
import styles from "./floatSidebarMenuToggler.module.css";
export default function SidebarMenuToggler({ onExpandedChanged, isExpanded }) {
    const onClick = () => {
        onExpandedChanged === null || onExpandedChanged === void 0 ? void 0 : onExpandedChanged(!isExpanded);
    };
    return (React.createElement(Button, { tooltipMessage: isExpanded ? "Свернуть" : "Развернуть", onClick: onClick, size: "32", styleType: "tonal", iconOnly: true, classNameContent: styles.content },
        React.createElement("i", { className: isExpanded ? "icon-sidebar-open" : "icon-sidebar-close" })));
}
